import { useEffect, useState } from 'react';
import { isQueueApi, queueApi } from './api';

/** One answer per doctor for a short while: the profile card and the queue box ask at the same moment. */
const answers = new Map<string, { at: number; enabled: Promise<boolean> }>();
const FRESH_MS = 30_000;

/** Whether the queue service has this doctor's queue on — false when it says no or does not answer. */
export const queueEnabled = (slug: string): Promise<boolean> => {
  if (!isQueueApi()) return Promise.resolve(true);
  const known = answers.get(slug);
  if (known && Date.now() - known.at < FRESH_MS) return known.enabled;
  const enabled = queueApi
    .summary(slug)
    .then(summary => !!summary?.enabled)
    .catch(() => false);
  answers.set(slug, { at: Date.now(), enabled });
  return enabled;
};

/**
 * For the rollout profile's card: `null` while the service has not answered, then its answer. Off (`active`
 * false) on every other profile — nothing is asked there.
 */
export const useQueueEnabled = (slug: string | null | undefined, active: boolean) => {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  useEffect(() => {
    if (!active || !slug) return;
    let cancelled = false;
    queueEnabled(slug).then(answer => !cancelled && setEnabled(answer));
    return () => {
      cancelled = true;
    };
  }, [slug, active]);
  return active ? enabled : null;
};
